import { render, staticRenderFns } from "./oilsInvoiceRecord.vue?vue&type=template&id=6aadb471&scoped=true&"
import script from "./oilsInvoiceRecord.vue?vue&type=script&lang=js&"
export * from "./oilsInvoiceRecord.vue?vue&type=script&lang=js&"
import style0 from "./oilsInvoiceRecord.vue?vue&type=style&index=0&id=6aadb471&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadb471",
  null
  
)

export default component.exports